import { MapObject } from "../../models/MapObject";
import { mapObjectColor } from "../Helper/Map";
import Arrow from "./SVGIcons/arrow_sdf_icon";
import Barbed_Wire from "./SVGIcons/barbed_wire_sdf_icon";
import Bullet from "./SVGIcons/bullet_sdf_icon";
import Crane from "./SVGIcons/crane_sdf_icon";
import Delivery_Truck from "./SVGIcons/delivery_truck_sdf_icon";
import Dumpster from "./SVGIcons/dumpster_sdf_icon";
import First_Aid from "./SVGIcons/first_aid_sdf_icon";
import Gate from "./SVGIcons/gate_sdf_icon";
import Left_Chevron from "./SVGIcons/left_chevron_sdf_icon";
import Left_Double_Chevron from "./SVGIcons/left_double_chevron_sdf_icon";
import Lightning from "./SVGIcons/lightning_sdf_icon";
import Map_Marker from "./SVGIcons/map_marker_sdf_icon";
import No_Entry from "./SVGIcons/no_entry_sdf_icon";
import No_Parking from "./SVGIcons/no_parking_sdf_icon";
import Parking_Sign from "./SVGIcons/parking-sign_sdf_icon";
import Portable_Toilet from "./SVGIcons/portable-toilet_sdf_icon";
import Right_Chevron from "./SVGIcons/right-chevron_sdf_icon";
import Right_Double_Chevron from "./SVGIcons/right-double-chevron_sdf_icon";
import Road_Barrier from "./SVGIcons/road-barrier_sdf_icon";
import Two_Way_1 from "./SVGIcons/two_way_sdf_icon_1";
import Two_Way_2 from "./SVGIcons/two_way_sdf_icon_2";
import Warning from "./SVGIcons/warning_sdf_icon";

interface IconMatcherProps {
    mapObject: MapObject;
}

const IconMatcher: React.FC<IconMatcherProps> = ({ mapObject }) => {
    if (!mapObject.icon) {
        return null;
    }
    let iconName = mapObject.icon;
    iconName = iconName.replace(/-/g, "_");

    const color = mapObjectColor(mapObject);
    const icons = {
        arrow_sdf_icon: <Arrow fill={color} />,
        barbed_wire_sdf_icon: <Barbed_Wire fill={color} />,
        bullet_sdf_icon: <Bullet fill={color} />,
        crane_sdf_icon: <Crane fill={color} />,
        delivery_truck_sdf_icon: <Delivery_Truck fill={color} />,
        dumpster_sdf_icon: <Dumpster fill={color} />,
        first_aid_sdf_icon: <First_Aid fill={color} />,
        gate_sdf_icon: <Gate fill={color} />,
        left_chevron_sdf_icon: <Left_Chevron fill={color} />,
        left_double_chevron_sdf_icon: <Left_Double_Chevron fill={color} />,
        lightning_sdf_icon: <Lightning fill={color} />,
        map_marker_sdf_icon: <Map_Marker fill={color} />,
        no_entry_sdf_icon: <No_Entry fill={color} />,
        no_parking_sdf_icon: <No_Parking fill={color} />,
        parking_sign_sdf_icon: <Parking_Sign fill={color} />,
        portable_toilet_sdf_icon: <Portable_Toilet fill={color} />,
        right_chevron_sdf_icon: <Right_Chevron fill={color} />,
        right_double_chevron_sdf_icon: <Right_Double_Chevron fill={color} />,
        road_barrier_sdf_icon: <Road_Barrier fill={color} />,
        two_way_sdf_icon_1: <Two_Way_1 fill={color} />,
        two_way_sdf_icon_2: <Two_Way_2 fill={color} />,
        warning_sdf_icon: <Warning fill={color} />,
    };
    return icons[iconName] || null;
};

export default IconMatcher;
